import TurtleIcon from "../AssistantWidget/TurtleIcon";
import styles from "./logo.module.scss";

interface LogoProps {
    // App-bar treatment used by the header's mobile/tablet layout: a smaller
    // tile, a single-line wordmark, and the byline/subtitle only when there is
    // room (see the .compact rules in logo.module.scss). The default output is
    // unchanged.
    compact?: boolean;
}

// NihongoTech's brand mark: かめ's turtle glyph + wordmark shown in the site
// header (see HeaderComponent.tsx, which wraps this in a NavLink to "/").
function Logo({ compact = false }: LogoProps) {
    return (
        <div className={compact ? `${styles.logoContainer} ${styles.compact}` : styles.logoContainer}>
            <div className={styles.iconWrapper}>
                <TurtleIcon size={40} className={styles.icon} />
            </div>
            <div className={styles.titleGroup}>
                <p className={styles.title}>
                    <span className={styles.wordmark}><span>Nihongo</span><span>Tech</span></span>{" "}<span className={styles.byline}>by TeqSeq</span>
                </p>
                <span className={styles.subtitle}>日本語オンラインキーボード</span>
            </div>
        </div>
    );
}

export default Logo;
